import React, { useState } from 'react';

import { IoMdAdd } from 'react-icons/io';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBin6Line } from 'react-icons/ri';

import './ContentChangeButton.css';

const ContentChangeButton = ({
  children,
  size = 'regular',
  width = 'small',
  iconType = 'no-icon',
  isDisabled,
  disabledMsg,
  onClickHandler,
  className,
  ...rest
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const renderDefaultButtonContent = () => {
    if (iconType === 'add') return <IoMdAdd />;
    if (iconType === 'edit') return <FiEdit2 />;
    if (iconType === 'delete') return <RiDeleteBin6Line />;
    return null;
  };

  const classNames = [
    'admin-edit-delete-btn',
    `admin-edit-delete-btn-size-${size}`,
    `admin-btn-width-${width}`,
    `admin-${iconType}-btn`,
    `${isDisabled ? 'disabled-button' : ''}`,
    className,
  ].join(' ');

  return (
    <div
      className='tooltip-wrapper'
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button
        disabled={isDisabled}
        onClick={onClickHandler}
        className={classNames}
        {...rest}
      >
        <div className='button-children-container'>
          {renderDefaultButtonContent()}
          {children}
        </div>
      </button>
      {isDisabled && showTooltip && disabledMsg && (
        <div className='tooltip'>{disabledMsg} </div>
      )}
    </div>
  );
};

export default ContentChangeButton;
